import { useCallback, useState } from "react";

import {
  clampTransportPosition,
  clampTransportSizeLevel,
  readTimelineUiPreferences,
  writeTimelineUiPreferences,
  type TimelineUiPreferences,
} from "@/lib/timeline/view/TimelineUiPreferences/prefs";

export function useTimelineUiPrefs() {
  const [uiPrefs, setUiPrefs] = useState<TimelineUiPreferences>(() => {
    return readTimelineUiPreferences();
  });

  const updateUiPrefs = useCallback((patch: Partial<TimelineUiPreferences>): void => {
    setUiPrefs((prev) => {
      const next: TimelineUiPreferences = {
        transportSizeLevel: clampTransportSizeLevel(
          patch.transportSizeLevel ?? prev.transportSizeLevel,
        ),
        transportPosition: clampTransportPosition(
          patch.transportPosition ?? prev.transportPosition,
        ),
        cameraLockEnabled: patch.cameraLockEnabled ?? prev.cameraLockEnabled,
        autoZoomEnabled: patch.autoZoomEnabled ?? prev.autoZoomEnabled,
        boardModelDebug: patch.boardModelDebug ?? prev.boardModelDebug,
        journey: patch.journey ?? prev.journey,
        spanId: patch.spanId ?? prev.spanId,
        repeatEnabled: patch.repeatEnabled ?? prev.repeatEnabled,
        optionsOpen: patch.optionsOpen ?? prev.optionsOpen,
        spoilerLevel: patch.spoilerLevel ?? prev.spoilerLevel,
      };
      if (
        next.transportSizeLevel === prev.transportSizeLevel
        && next.transportPosition.x === prev.transportPosition.x
        && next.transportPosition.y === prev.transportPosition.y
        && next.cameraLockEnabled === prev.cameraLockEnabled
        && next.autoZoomEnabled === prev.autoZoomEnabled
        && next.boardModelDebug === prev.boardModelDebug
        && next.journey === prev.journey
        && next.spanId === prev.spanId
        && next.repeatEnabled === prev.repeatEnabled
        && next.optionsOpen === prev.optionsOpen
        && next.spoilerLevel === prev.spoilerLevel
      ) {
        return prev;
      }
      writeTimelineUiPreferences(next);
      return next;
    });
  }, []);

  return { uiPrefs, updateUiPrefs };
}
